const styles = theme => ({
  root: {
    backgroundColor: '#F5F6F7',
    borderRadius: '2px',
    display: 'flex',
    padding: '32px 46px 32px 32px'
  },
  deliveryInfo: {
    flex: 1
  },
  organizationName: {
    marginBottom: `${theme.spacing.unit * 2}px !important`
  },
  priceInfo: {
    textAlign: 'center'
  },
  price: {
    fontWeight: '400 !important',
    marginBottom: `${theme.spacing.unit}px !important`
  },
  captionText: { color: 'rgba(12,31,44,0.87) !important' },
  noRate: {
    textAlign: 'center',
    width: '100%'
  }
});

export default styles;
